<div class="section">
  <div class="row">
    <div class="col-12 col-lg-7 col--flex">
      <h3 class="title-with-icon">
        <svg-icon src="assets/images/icons/accesspoint.svg" class="black-medium"></svg-icon>
        <span>{{ "Wireless.AccessPoints.Title" | translate }}</span>
      </h3>
      <access-points [accessPoints]="accessPoints()" [apCountsByModel]="apCountsByModel()"></access-points>
    </div>
    <div class="col-12 col-lg-5 col--flex">
      <h3 class="title-with-icon">
        <svg-icon src="assets/images/icons/usergroup.svg" class="black-medium"></svg-icon>
        <span>{{ "Wireless.Stats.MaxUsers" | translate }}</span>
      </h3>
      @if (kpis()) {
        <user-stats [kpis]="kpis()"></user-stats>
      }
    </div>
  </div>
</div>
